import { render } from "./Potensi.vue?vue&type=template&id=1cc3b973"
import script from "./Potensi.vue?vue&type=script&lang=js"
export * from "./Potensi.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__